export const cryptoPolicyURL = "https://monfibank.com/privacy-policy";
export const cryptoTremsCondiations = "https://monfibank.com/terms-and-conditions";
